import { useEffect } from "react";
import { title as baseTitle } from "config";
import { usePortalContext } from "context";

export function useRawSetTitle(title) {
  useEffect(() => {
    document.title = baseTitle + (title ? ": " + title : "");
  }, [title]);
}

export function useSetTitle(title) {
  const { authenticatedAsStaff } = usePortalContext();
  const adjustedTitle =
    title === null
      ? authenticatedAsStaff
        ? "Staff Access"
        : null
      : title + (authenticatedAsStaff ? " (as staff)" : "");
  useRawSetTitle(adjustedTitle);
}
